export default __webpack_public_path__ + "static/media/paar.34be4f91.svg";